module.exports = __webpack_public_path__ + "assets/img/11_669_big.0c63185e.jpg";